(function () {
  function injectFontCss(root) {
    var styleId = root.getAttribute('data-font-style-id');
    if (!styleId || document.getElementById(styleId)) return;

    var fontScript = root.querySelector('[data-stock-notice-font-css]');
    if (!fontScript) return;

    var css = '';
    try {
      css = JSON.parse(fontScript.textContent);
    } catch (e) {
      css = '';
    }
    if (!css) return;

    var styleEl = document.createElement('style');
    styleEl.id = styleId;
    styleEl.textContent = css;
    document.head.appendChild(styleEl);
  }

  function initStockNotice(root) {
    if (!root || root.dataset.stockNoticeInit === 'true') return;
    root.dataset.stockNoticeInit = 'true';

    injectFontCss(root);

    var textEl = root.querySelector('[data-stock-notice-text]');
    var variantsScript = root.querySelector('[data-stock-notice-variants]');
    var variants = {};
    try {
      variants = variantsScript ? JSON.parse(variantsScript.textContent) : {};
    } catch (e) {
      variants = {};
    }

    var formId = root.getAttribute('data-form-id');
    var threshold = parseInt(root.getAttribute('data-stock-threshold'), 10) || 3;
    var messageTemplate =
      root.getAttribute('data-message-template') || 'Poco stock · Solo quedan [count] unidades';

    function getSelectedVariantId() {
      var form = formId ? document.getElementById(formId) : null;
      if (form) {
        var input = form.querySelector('[name="id"]');
        if (input && input.value) return String(input.value);
      }
      var params = new URLSearchParams(window.location.search);
      if (params.get('variant')) return String(params.get('variant'));
      var keys = Object.keys(variants);
      return keys.length ? keys[0] : null;
    }

    function formatMessage(qty) {
      return messageTemplate.replace(/\[count\]/g, String(qty));
    }

    function updateForVariant(variantId) {
      if (!variantId || !variants[variantId]) {
        root.hidden = true;
        root.style.display = 'none';
        if (textEl) textEl.textContent = '';
        return;
      }

      var data = variants[variantId];
      var qty = parseInt(data.inventory_quantity, 10) || 0;
      var show = data.low_stock === true && qty > 0 && qty <= threshold;

      if (show) {
        root.hidden = false;
        root.style.display = 'flex';
        if (textEl) textEl.textContent = formatMessage(qty);
      } else {
        root.hidden = true;
        root.style.display = 'none';
        if (textEl) textEl.textContent = '';
      }
    }

    updateForVariant(getSelectedVariantId());

    var form = formId ? document.getElementById(formId) : null;
    if (form) {
      form.addEventListener('change', function () {
        updateForVariant(getSelectedVariantId());
      });
    }

    document.addEventListener('variant:changed', function () {
      updateForVariant(getSelectedVariantId());
    });
  }

  function initAll() {
    document.querySelectorAll('[data-stock-notice]').forEach(initStockNotice);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
